import script from "./FenXiaoFanYong.vue?vue&type=script&setup=true&lang=js"
export * from "./FenXiaoFanYong.vue?vue&type=script&setup=true&lang=js"

import "./FenXiaoFanYong.vue?vue&type=style&index=0&id=1356e27c&scoped=true&lang=css"

import exportComponent from "D:\\fxwl\\wx-wl_full\\wx-wl_full\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1356e27c"]])

export default __exports__